<template>
    <div :class="classes">
      <span v-if="hasSlot" :class="slotClasses">
        <slot></slot>
      </span>
      <span v-if="oper.length>0" :class="operClasses">
        <mButton
                 v-for="(item, index) in oper"
                 :key="index"
                 size="xs"
                 :icon="item.icon"
                 type="ghost"
                 :title="item.title"
                 @click = "submitOper(item)"
        >
          </mButton>
      </span>
    </div>
</template>

<script>
  import {oneOf} from "../assist/assist";
  import mButton from '@/components/button/m-button'
  const prefixCls = 'mvu-divider';
  export default {
    name: "m-divider",
    components:{mButton},
    props:{
          type:{
          validator:(value) =>{
           return oneOf(value,['horizontal','vertical'])
          },
            default:'horizontal'
          },
        orientation:{
            validator:(value)=>{
              return oneOf(value,['left','center','right'])
            },
          default: 'center'
        },
        icon:{
          type:Boolean,
          default:false,
        },
        oper: {
          type:Array,
          default:()=>{
            return []
          },
        },
      },
    computed:{
        classes(){
          return [
            `${prefixCls}`,
            `${prefixCls}-${this.type}`,
            {
              [`${prefixCls}-with-icon-${this.orientation}`]:this.icon && this.hasSlot,
              [`${prefixCls}-with-text-${this.orientation}`]: !this.icon && this.hasSlot,
            }

          ]
        },
        hasSlot(){
          let showSlot = this.$slots.default;
          if(this.icon){
            showSlot = true;
          }
          return !!showSlot
        },
        slotClasses(){
          return {
            [`${prefixCls}-inner-text`]:!this.icon && this.hasSlot,
            [`${prefixCls}-inner-icon`]:this.icon && this.hasSlot,
            [`${prefixCls}-inner-text-oper`]:this.hasSlot && this.oper.length>0,
            }

        },
        operClasses(){
          return {
            [`${prefixCls}-inner-oper`]:this.hasSlot && this.oper.length>0,

          }
        }
      },
    methods:{
      submitOper(item){
        this.$emit('on-click',item)
      }
    },
    }
</script>

<style scoped>
@import "m-divider.css";
  .x{
    float: left;

  }
</style>
